module.exports = __webpack_public_path__ + "static/media/project-register-step1.3d5f22fc.svg";